import { create } from 'zustand';

interface EditingFieldsState {
  editingFields: Set<string>;
  setFieldEditing: (fieldName: string, isEditing: boolean) => void;
  isFieldEditing: (fieldName: string) => boolean;
  clearAllEditing: () => void;
}

export const useEditingFieldsStore = create<EditingFieldsState>((set, get) => ({
  editingFields: new Set<string>(),
  setFieldEditing: (fieldName: string, isEditing: boolean) =>
    set((state) => {
      const newSet = new Set(state.editingFields);
      if (isEditing) {
        newSet.add(fieldName);
      } else {
        newSet.delete(fieldName);
      }
      return { editingFields: newSet };
    }),
  isFieldEditing: (fieldName: string) => get().editingFields.has(fieldName),
  clearAllEditing: () => set({ editingFields: new Set<string>() })
}));

